import { cx } from '@/shared/lib/cx';

import styles from './progress-bar.module.scss';

export type ProgressBarProps = {
  value: number;
  label: string;
  tone?: 'accent' | 'inverse';
  thickness?: 2 | 3;
  /** "soft" — the lighter track of the size advisor (03B). */
  track?: 'default' | 'soft';
  className?: string | undefined;
};

export function ProgressBar({
  value,
  label,
  tone = 'accent',
  thickness = 3,
  track = 'default',
  className,
}: ProgressBarProps) {
  const clamped = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
  const style = { '--progress': `${clamped}%` };
  return (
    <div
      className={cx(styles.root, className)}
      data-tone={tone}
      data-thickness={thickness}
      data-track={track}
    >
      {/* The native element carries the semantics; the bar is drawn by the span. */}
      <progress
        className={styles.native}
        value={Math.round(clamped)}
        max={100}
        aria-label={label}
      />
      <span className={styles.fill} style={style} aria-hidden="true" />
    </div>
  );
}
